import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react";
import * as React from "react";

type Positioning = React.ComponentProps<
  typeof ChakraTooltip.Root
>["positioning"];

interface TooltipProps {
  content: React.ReactNode;
  positioning?: Positioning;
  /** Must be a single element that accepts a ref: it becomes the trigger. */
  children: React.ReactNode;
}

export function Tooltip({
  children,
  content,
  positioning = { placement: "top" },
}: TooltipProps) {
  return (
    <ChakraTooltip.Root
      openDelay={100}
      closeDelay={100}
      positioning={positioning}
    >
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      {/* Portalled so the content never lands inside a trigger's own <p> or
          gets clipped by a scroll container. */}
      <Portal>
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content
            background="gray.900"
            borderRadius="l2"
            color="white"
            fontSize="xs"
            lineHeight={"18px" as any}
            maxWidth={"250px" as any}
            paddingX="3"
            paddingY="2.5"
          >
            <ChakraTooltip.Arrow>
              <ChakraTooltip.ArrowTip
                background="gray.900!important"
                borderWidth="0!important"
              />
            </ChakraTooltip.Arrow>
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
}
